module.exports = "<div class=\"row\">\n    <div class=\"col-md-6 text-center\">\n        <i class=\"fa fa-fw fa-2x fa-shopping-cart\"></i><br/>\n        Go to Cart\n    </div>\n    <div class=\"col-md-6\">{{ ngCart.getTotalItems() }}\n        <ng-pluralize count=\"ngCart.getTotalItems()\" when=\"{1: 'item', 'other':'items'}\"></ng-pluralize>\n        <br />{{ ngCart.totalCost() | currency }}\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/ng-cart/summary.html
// module id = 942
// module chunks = 0